<template>
  <div class="container-card-item">
    <b-card-text class="title-card-item">{{ title }}</b-card-text>
    <b-card-text class="text-card-item">{{ text }}</b-card-text>
  </div>
</template>

<script>
export default {
  name: "item-card",
  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.container-card-item {
  display: flex;
}
.title-card-item {
  font-weight: 700;
  margin-right: 5px;
}

.text-card-item {
  word-break: break-all;
}

.card-text {
  margin-bottom: 2px;
}
</style>
